<template>
  <span>
    <canvas
      id="s-canvas"
      :width="contentWidth"
      :height="contentHeight"
    ></canvas>
  </span>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'SIdentify',
  props: {
    identifyCode: { //默认注册码
      type: String,
      default: '1234'
    },
    fontSizeMin: { // 字体最小值
      type: Number,
      default: 24
    },
    fontSizeMax: { // 字体最大值
      type: Number,
      default: 24
    },
    backgroundColor: {  // 验证码图片背景色最大值
      type: String,
      default: 'rgb(209, 209, 209)'
    },
    dotColorMin: { // 背景干扰点最小值
      type: Number,
      default: 1
    },
    dotColorMax: { // 背景干扰点最大值
      type: Number,
      default: 1
    },
    contentWidth: { //容器宽度
      type: Number,
      default: 80
    },
    contentHeight: { //容器高度
      type: Number,
      default: 40
    },
    textHeight: { //文字高度
      type: Number,
      default: 28
    },
    contentColor: { //文字颜色
      type: String
    },
    borderColor: { //匡线颜色
      type: String
    }
  },
  computed: {
    ...mapGetters(['windosize'])
  },
  methods: {
    // 生成一个随机数
    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    // 生成一个随机的颜色
    randomColor (min, max) {
      let r = this.randomNum(min, max)
      let g = this.randomNum(min, max)
      let b = this.randomNum(min, max)
      return 'rgb(' + r + ',' + g + ',' + b + ')'
    },
    drawPic () {
      let canvas = document.getElementById('s-canvas')
      let ctx = canvas.getContext('2d')
      ctx.textBaseline = 'bottom'
      // 绘制背景
      ctx.fillStyle = this.backgroundColor
      ctx.fillRect(0, 0, this.contentWidth, this.contentHeight)
      // 绘制文字
      for (let i = 0; i < this.identifyCode.length; i++) {
        this.drawText(ctx, this.identifyCode[i], i)
      }
      // this.drawLine(ctx)
      // this.drawDot(ctx)
    },
    drawText (ctx, txt, i) {
      ctx.fillStyle = this.contentColor || this.randomColor(30, 80) //随机生成字体颜色
      ctx.font = this.randomNum(this.fontSizeMin, this.fontSizeMax) + 'px SimHei' //随机生成字体大小
      let x = (i + 0.5) * ((this.contentWidth - 10) / (this.identifyCode.length))
      let y = this.randomNum(this.textHeight, this.textHeight)
      var deg = this.randomNum(0, 0)
      // 修改坐标原点和旋转角度
      x = x - 3,
        ctx.translate(x, y)
      ctx.rotate(deg * Math.PI / 180)
      ctx.fillText(txt, 0, 0)
      // 恢复坐标原点和旋转角度
      ctx.rotate(-deg * Math.PI / 180)
      ctx.translate(-x, -y)
    },
    drawLine (ctx) {
      // 绘制干扰线
      for (let i = 0; i < 4; i++) {
        ctx.strokeStyle = this.randomColor(100, 200)
        ctx.beginPath()
        ctx.moveTo(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight))
        ctx.lineTo(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight))
        ctx.stroke()
      }
    },
    drawDot (ctx) {
      // 绘制干扰点
      for (let i = 0; i < 30; i++) {
        ctx.fillStyle = this.randomColor(0, 255)
        ctx.beginPath()
        ctx.arc(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight), 1, 0, 2 * Math.PI)
        ctx.fill()
      }
    }
  },
  watch: {
    identifyCode () {
      this.drawPic()
    },
    contentWidth () {
      this.$nextTick(() => {
        this.drawPic()
      })
    }
  },
  mounted () {
    this.drawPic()
  }
}
</script>
<style >
#s-canvas {
  display: block;
  cursor: pointer;
}
</style>
